import { signInWithEmailAndPassword, signOut, onAuthStateChanged, User } from 'firebase/auth';
import { auth } from './firebase';

export const login = async (email: string, password: string) => {
  try {
    if (!email || !password) {
      return { user: null, error: 'Email e senha são obrigatórios.' };
    }

    const result = await signInWithEmailAndPassword(auth, email, password);
    return { user: result.user, error: null };
  } catch (error) {
    console.error('Erro no login:', error);
    if (error.code === 'auth/invalid-credential') {
      return { user: null, error: 'Email ou senha incorretos.' };
    }
    if (error.code === 'auth/too-many-requests') {
      return { user: null, error: 'Muitas tentativas de login. Tente novamente mais tarde.' };
    }
    return { user: null, error: 'Erro ao fazer login. Tente novamente.' };
  }
};

export const logout = async () => {
  try {
    await signOut(auth);
    return { error: null };
  } catch (error) {
    console.error('Erro no logout:', error);
    return { error: 'Falha ao fazer logout.' };
  }
};

export const subscribeToAuthChanges = (callback: (user: User | null) => void) => {
  return onAuthStateChanged(auth, callback);
};